import { render } from "./SwdModalSummaryInfo.vue?vue&type=template&id=6647a775"
import script from "./SwdModalSummaryInfo.vue?vue&type=script&lang=js"
export * from "./SwdModalSummaryInfo.vue?vue&type=script&lang=js"

import "./SwdModalSummaryInfo.vue?vue&type=style&index=0&id=6647a775&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__